import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-400 py-10 border-t border-gray-800" data-id="element-162">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center" data-id="element-163">
        <h2 className="text-2xl font-serif font-bold text-brand-gold mb-3" data-id="element-164">
          🥖 MIGA MASTER PRO™
        </h2>
        <p className="mb-1 text-gray-300" data-id="element-165">
          El sistema de emprendimiento gastronómico N°1 para hacer sándwiches de
          miga desde casa en Argentina.
        </p>
        <p className="mb-5 italic" data-id="element-166">
          Porque emprender con sándwiches no debería costarte todos los fines de
          semana del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-6 text-sm" data-id="element-167">
          <a href="mailto:soporte@migamasterpro.com" className="hover:text-brand-gold transition-colors" data-id="element-168">
            📧 soporte@migamasterpro.com
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-169">
            📲 @migamasterpro
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-170">
            🌐 www.migamasterpro.com
          </a>
        </div>

        <div className="text-xs border-t border-gray-800 pt-5" data-id="element-171">
          <p className="mb-1" data-id="element-172">
            © Miga Master Pro™ 2025 — Todos los derechos reservados.
          </p>
          <p className="mb-4" data-id="element-173">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-brand-gold font-serif text-lg italic" data-id="element-174">
            🥖 "El próximo pedido puede cambiar tu vida."
          </p>
        </div>
      </div>
    </footer>;
}